module.exports = __webpack_public_path__ + "img/c04.08c6baaa.png";